import {
  Menu as MuiMenu,
  MenuItem as MuiMenuItem,
  type MenuItemProps as MuiMenuItemProps,
  MenuList as MuiMenuList,
  type MenuListProps as MuiMenuListProps,
  type MenuProps as MuiMenuProps
} from "@mui/material";

export type MenuProps = MuiMenuProps;
export type MenuItemProps = MuiMenuItemProps;
export type MenuListProps = MuiMenuListProps;

export const Menu = MuiMenu;
export const MenuItem = MuiMenuItem;
export const MenuList = MuiMenuList;
